import styled from "styled-components/macro";

// export const PopUpBox = styled.div`
// height: 272px;
// width: 100%;
// `

export const PopUpBox = styled.div`
  /* grid-area: smartkeys; */
  background: var(--clr-settingsbg);
  /* height: ${({ full }) => full && "276px"}; */
  height: 276px;
`;

export const PopUpHeadingWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.5rem;
  gap: 0.5em;
  margin-left: 1em;
  padding-top: 1em;
`;

export const PopUpIconWrapper = styled.div`
  height: 25px;
  width: auto;
`;

export const PopUpImgWrapper = styled.div`
  height: 25px;
  width: auto;
  padding-left: 0;
`;

// Icon (maybe create icon wrapper )

// change font size if needed
export const PopUpTitle = styled.div``;
